import * as s from './styles';
import type { IFullColumnTextCta } from './types';

const FullColumnTextCta  = ({ buttons, headline }: IFullColumnTextCta) => (
  <s.StyledFinalCta>
    <s.FinalCtaGrid>
      {headline && (
        <s.StyledHeadline
          colorVariant='light'
          forwardedAs='h2'
          variant='h2'
          dangerouslySetInnerHTML={{ __html: headline }}
        />
      )}
      {buttons && (
        <s.StyledButtons
        buttonColor="light"
        variants={['ghost']}
        buttons={buttons}
      />)}
    </s.FinalCtaGrid>
  </s.StyledFinalCta>
);

export default FullColumnTextCta;
